import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, Optional } from '@angular/core';
import { DpadZoneDirective } from './dpad-zone.directive';
import { DpadScrollableVerticalDirective } from './dpad-scrollable-vertical.directive';
import { DpadScrollableHorizontalDirective } from './dpad-scrollable-horizontal.directive';

@Directive({
    selector: '[dpadSelectable]'
})
export class DpadSelectableDirective implements AfterViewInit, OnDestroy {

    @Input() dpadSelectable: string = '';
    @Input() scrollTo: boolean = false;
    @Input() scrollTypeVertical: 'center' | 'top' | 'bottom';
    @Input() scrollTypeHorizontal: 'center' | 'left' | 'right';
    @Input() scrollPaddingVertical: number | undefined;
    @Input() scrollPaddingHorizontal: number | undefined;
    @Input() dindex: number = -1;

    constructor(private elem: ElementRef,
        private zone: DpadZoneDirective,
        @Optional() private scrollContainerVertical: DpadScrollableVerticalDirective,
        @Optional() private scrollContainerHorizontal: DpadScrollableHorizontalDirective) {
    }

    ngAfterViewInit(): void {
        this.zone.addSelectable(this);

        if (this.elem.nativeElement.localName === 'div' && this.elem.nativeElement.tabIndex === -1) {
            this.elem.nativeElement.tabIndex = 0;
        }

        if (this.start()) {
            this.focus();
            this.zone.focus();
        }
    }

    ngOnDestroy(): void {
        if (this.zone) {
            this.zone.removeSelectable(this);
        }
    }

    @HostListener('click', ['$event'])
    onClick(event) {
        event.stopPropagation();
        this.focus();
    }

    selected() {
        return document.activeElement === this.elem.nativeElement;
    }

    focus() {
        this.elem.nativeElement.focus();
        this.zone.setLastFocus(this);
        this.scrollToElement();
    }

    scrollToElement() {
        if (this.scrollTo && this.scrollContainerVertical && this.scrollContainerVertical.isScrollable) {
            this.scrollContainerVertical.scrollIntoView(this.elem.nativeElement, this.scrollTypeVertical, this.scrollPaddingVertical);
        }
        if (this.scrollTo && this.scrollContainerHorizontal && this.scrollContainerHorizontal.isScrollable) {
            this.scrollContainerHorizontal.scrollIntoView(this.elem.nativeElement, this.scrollTypeHorizontal, this.scrollPaddingHorizontal)
        }
    }

    x(): number {
        return this.elem.nativeElement.getBoundingClientRect().x;
    }

    xEnd(): number {
        return this.elem.nativeElement.getBoundingClientRect().x + this.elem.nativeElement.offsetWidth;
    }

    xMid(): number {
        return this.elem.nativeElement.getBoundingClientRect().x + (this.elem.nativeElement.offsetWidth / 2);
    }

    y(): number {
        return this.elem.nativeElement.getBoundingClientRect().y;
    }

    yEnd(): number {
        return this.elem.nativeElement.getBoundingClientRect().y + this.elem.nativeElement.offsetHeight;
    }

    yMid(): number {
        return this.elem.nativeElement.getBoundingClientRect().y + (this.elem.nativeElement.offsetHeight / 2);
    }

    start(): boolean {
        if (this.elem.nativeElement.classList.contains('dpad-start')) {
            return true;
        }
        return false;
    }

    zoneStart(): boolean {
        if (this.elem.nativeElement.classList.contains('dpad-zone-start')) {
            return true;
        }
        return false;
    }
}
